export const MANDATORY_WEIGHT_REQUEST = 'MANDATORY_WEIGHT_REQUEST';
export const MANDATORY_WEIGHT_SUCCESS = 'MANDATORY_WEIGHT_SUCCESS';
export const MANDATORY_WEIGHT_FAIL = 'MANDATORY_WEIGHT_FAIL';

